import {
  ButtonBaseProps,
  IconButton,
  IconButtonProps,
  styled,
} from "@mui/material";
import React, {
  ForwardRefExoticComponent,
  ReactElement,
  RefAttributes,
} from "react";
import { LinkProps } from "react-router";

type Props = {
  children: React.ReactNode;
  to?: string;
  component?: ForwardRefExoticComponent<
    LinkProps & RefAttributes<HTMLAnchorElement>
  >;
  color?: string;
} & ButtonBaseProps &
  IconButtonProps;

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.custom.fillSecondary,
  color: theme.palette.text.main,
  "&:hover": {
    background: theme.palette.custom.fillSecondaryHover,
  },

  "&.MuiIconButton-colorPrimary": {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },

  "&.MuiIconButton-colorSecondary": {
    backgroundColor: theme.palette.custom.fillSecondary,
    color: theme.palette.text.main,
    "&:hover": {
      background: theme.palette.custom.fillSecondaryHover,
    },
  },
}));

export function IconButtonContained({
  children,
  color,
  ...rest
}: Props): ReactElement {
  return (
    <StyledIconButton color={color} {...rest}>
      {children}
    </StyledIconButton>
  );
}
